import { createGlobalStyle, keyframes } from 'styled-components'
import { CSSReset } from './CSSReset'
import { Theme } from './Theme'
import { mimicButtonStyles } from './matieralui/Button'


export const GlobalStyleSheet = createGlobalStyle`
    ${CSSReset}
    body {
        background-color: ${Theme.colors.base};
        color: ${Theme.colors.dark};
        // font-family: 'Roboto', sans-serif;
        /* font-family: 'Poppins', sans-serif; */
        /* font-weight: 400;
        line-height: ${Theme.lineHeight}; */
        font-family: ${Theme.CaptureCollabStyles.fonts.body} !important;
        font-weight: ${Theme.CaptureCollabStyles.fonts.bodyWeight};
        line-height: ${Theme.CaptureCollabStyles.fonts.bodyLineHeight};
    }

    a {
        color: ${Theme.colors.primary};
        text-decoration: none;
    }
    .button-primary {
        ${mimicButtonStyles}
        color: ${Theme.colors.primaryText};
        background-color: ${Theme.colors.primary};
    }
    .button-outlined {
        ${mimicButtonStyles}
        border: 1px solid;
        padding: 5px 15px;
    }
    /* .MuiTypography-root,
    .MuiButton-root,
    .MuiTab-root,
    .MuiInputBase-root,
    .MuiPaper-root {
        font-family: ${Theme.CaptureCollabStyles.fonts.body} !important;
    } */
    [class^="Mui"]{
        font-family: ${Theme.CaptureCollabStyles.fonts.body} !important;
    }
    

`

export const SkeletonAnimation = keyframes`
    0% {
        opacity: 0.15
    }
    50% {
        opacity: 0.90
    }
    100% {
        opacity: 0.15
    }
`;

export const SavingAnimation = keyframes`
    0% {
        opacity: 0.15
    }
    50% {
        opacity: 0.70
    }
    100% {
        opacity: 0.15
    }
`;